import { render, staticRenderFns } from "./infobar.vue?vue&type=template&id=3278712b&scoped=true&lang=pug"
import script from "./infobar.vue?vue&type=script&lang=js"
export * from "./infobar.vue?vue&type=script&lang=js"
import style0 from "./infobar.vue?vue&type=style&index=0&id=3278712b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3278712b",
  null
  
)

export default component.exports